module.exports = __webpack_public_path__ + "dingbeauty-landing/img/img_cloud.fb6c5565.png";